import { connect } from "react-redux";
import SummaryCard from "../components/SummaryCard";
const mapStateToProps = (state) => ({
    isSPA: state.getIn(["uiState", "isSPA"])
});
const SummaryCardWithSubscription = connect(mapStateToProps, null)(SummaryCard);
export default SummaryCardWithSubscription;
